import { Token } from "antlr4ts";
import { AST } from "./ir/ast";

export enum SemanticErrorCause {
    DOUBLE_DECLARATION_PROGRAM_NAME,
    DOUBLE_DECLARATION_PROGRAM_PARAMETER,
    INVALID_PROGRAM_NAME,
    TOO_MANY_ARGUMENTS,
    NOT_ENOUGH_ARGUMENTS,
    NO_SUCH_PROGRAM,
    NO_SUCH_VARIABLE,
}

export class SemanticError extends Error {
    constructor(
        public readonly cause: SemanticErrorCause,
        public readonly ast: AST,
        public readonly token: Token | undefined,
        public readonly translationParameters: { [key: string]: string },
    ) {
        super();
    }
}



// WEBPACK FOOTER //
// ./src/app/xlogo-parser/semanticError.ts